import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import moment from 'moment';
//import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import GraphAnnotation from '../../../containers/graphAnnotation.js';
import GraphPlotline from '../../../containers/graphPlotline.js';
import AnnotationsFactory from 'highcharts/modules/annotations';
import JSZip from 'jszip';
import { downloaduploadedDocumentsOnAPICall } from '../../../constants/ApiConstants';
import { getSVG, svgToPng } from '../../../../../actions/utilAction';
import RaisedButton from 'material-ui/RaisedButton';
AnnotationsFactory(Highcharts);
Exporting(Highcharts);
ExportingData(Highcharts);


class TimeOfDayGraph extends Component {

    constructor(props) {
        super(props);        
        this.state = {            
            sliderMaxValue: props.yAxisMaxValue ? props.yAxisMaxValue : 24,
            sliderValue: props.yAxisMaxValue ? props.yAxisMaxValue : 24,
            AnnotationLabel : [],
            BaselineLabel : [],
            xAxisDateOption: [],
            chartArray: [],
            behaviorNameArray: [],
          };
        //this.onSliderChange = this.onSliderChange.bind(this);
        this.setAnnotationState = this.setAnnotationState.bind(this);
        this.setBaselineState = this.setBaselineState.bind(this);
      }

    componentDidMount = () => {
        this.highchartsHandler();
    }

     // This method will be sent to the child component
     setAnnotationState(AnnotationState) {
        let annotationLabel = []; 
        annotationLabel.push(AnnotationState);       
        this.setState({
            AnnotationLabel: annotationLabel
        },()=>this.highchartsHandler());
    }

    // This method will be sent to the child component
    setBaselineState(BaselineState) {          
        this.setState({
            BaselineLabel: BaselineState
        },()=> this.highchartsHandler());
    }

    highchartsHandler = () => {
        let finalData = [];
        let behaviorsReductionId = [];
        let xAxisDate = [];
        let graphTitle = [];
        // let FromDate = moment(this.props.FromDate, 'YYYY-MM-DD');
        // let ToDate = moment(this.props.ToDate, 'YYYY-MM-DD');
        // let diff = ToDate.diff(FromDate, 'days', false);
        // diff = diff + 1;
        let xAxisLabel = this.props.xAxisName === undefined ? 'Data' : this.props.xAxisName;
        let yAxisLabel = this.props.yAxisName === undefined ? 'Date' : this.props.yAxisName;
        let disableYaxislabel = this.props.disableYaxislabel;
        let disableXaxislabel = this.props.disableXaxislabel;
        let disableLegend = this.props.disableLegend;
        let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
        //let selectedProgram = this.props.selectedProgram;
        if (this.props.dataAnalytics.DCPatientBehaviourGraphData !== null && this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.length > 0) {
            this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.map((obj, index) => {
                let dataObj = {}
                let behaviorData = [];
                let behaviordataForDate = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs;
                for (let i = 0; i < behaviordataForDate.length; i++) {
                    if(xAxisDate.indexOf(moment(behaviordataForDate[i].dos).format('MM/DD/YYYY')) === -1)
                    {
                        xAxisDate.push(moment(behaviordataForDate[i].dos).format('MM/DD/YYYY'));
                    }
                }

                if(behaviorsReductionId.indexOf(obj.behaviorsReductionId) === -1)
                {
                    let behaviorName = '';
                    let goaldata = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.filter((op) => op.behaviorsReductionId === obj.behaviorsReductionId);
                    behaviorData = [];
                    for (let i = 0; i < goaldata.length; i++) {
                        dataObj['name'] = goaldata[i].behaviorName;
                        dataObj['behaviorsReductionId'] = goaldata[i].behaviorsReductionId;
                        behaviorName = goaldata[i].behaviorName;
                        behaviorsReductionId.push(goaldata[i].behaviorsReductionId);
                        if(xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY')) > -1)
                        {
                            let index = xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY'));
                            behaviorData[index] = parseFloat((goaldata[i].behaviorData).replace(/:/g, "."));
                            // behaviorData.push(goaldata[i].behaviorData);
                        }
                    }

                    for(let j = 0; j < behaviorData.length; j++)
                    {
                        if(!behaviorData[j])
                        {
                            behaviorData[j] = null;
                        }
                    }
                    dataObj['data'] = behaviorData;
                    finalData.push(dataObj);
                    graphTitle.push(behaviorName);
                }
            })


            if(this.props.phaseChangeLineDataFlag && !this.props.displaySavedPhaseChangeLines)
            {
                this.setState({ BaselineLabel: [] });
            }
    
            if(this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && this.props.displaySavedPhaseChangeLines)
            {
                let phaseChangeLineData = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionPhaseChangeLineGraphs;
                let BaselineState = this.state.BaselineLabel;  
                for (let k = 0; k < phaseChangeLineData.length; k++) {                          
                    let lineIndex = xAxisDate.indexOf(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));    
                    var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                        if(data.key === phaseChangeLineData[k].lineLabel)
                            return true;
                    });
                    // if (indexValue !== -1) 
                    //     this.state.BaselineLabel.splice(indexValue, 1);
    
                    if(indexValue === -1 && Number(lineIndex) >= 0 && phaseChangeLineData[k].lineLabel)
                    {  
                        let label = {
                                        id: 'plotLine_' + Math.random(),
                                        value: Number(lineIndex),
                                        color: '#000000',
                                        width: 2,
                                        key: phaseChangeLineData[k].lineLabel,
                                        dashStyle: phaseChangeLineData[k].lineTypeName,                   
                                        label: {
                                            text: phaseChangeLineData[k].lineLabel
                                        },
                                        events: {
                                            dblclick: function(e) {
                                                this.axis.removePlotLine(this.id)
                                            }
                                        }
                                    };
                        
                        BaselineState.push(label);                                    
                    }
                }
                
                this.props.setPhaselineState(false);            
                this.setBaselineState(BaselineState);                  
            }
            else if(this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && !this.props.displaySavedPhaseChangeLines)
            {
                let phaseChangeLineData = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionPhaseChangeLineGraphs;
                let BaselineState = this.state.BaselineLabel;  
                
                for (let k = 0; k < phaseChangeLineData.length; k++) {                         
                    
                    var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                        if(data.key === phaseChangeLineData[k].lineLabel)
                            return true;
                    });
                    if (indexValue !== -1) 
                        this.state.BaselineLabel.splice(indexValue, 1);
                }
                
                this.props.setPhaselineState(false);            
                this.setBaselineState(BaselineState);  
            }
    
        }

        if(xAxisDate.length && this.state.xAxisDateOption.length != xAxisDate.length)
            {
                let xAxisDate1 = [];
    
                xAxisDate1 = xAxisDate.map((d,i)=>{
                    return {
                        'id':i,
                        'value':d.toString()
                    }
                })
                
                this.setState({xAxisDateOption: xAxisDate1}
                    ,()=>{ this.setState({})}
                    );           
            }

        graphTitle.reverse();  
        finalData.reverse();
        Highcharts.setOptions({
            colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000']
        });

        let behaviorsReductionId1 = [];
        let chartArray = [];
        let arrIndex = 0;
        let behaviorNameArray = [];
        this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.length > 0 && 
        this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.map((obj, index) => {
            if(behaviorsReductionId1.indexOf(obj.behaviorsReductionId) === -1)
            {
                let chart = null;
                behaviorsReductionId1.push(obj.behaviorsReductionId);
                behaviorNameArray.push(obj.behaviorName);       
                // console.log('behaviorsReductionId1...........',behaviorsReductionId1)
                // console.log('finalData...........',finalData)
                // console.log('finalData[index]...........',finalData[index])
                // console.log('arrIndex...........',arrIndex)
                Highcharts.chart(`analyticsDataDiv[${index}]`, {

                    chart: {
                        type: 'scatter',
                        zoomType: 'xy'
                    },

                    title: {
                        text: `<b>${graphTitle[arrIndex]}</b>`,
                    },
                    annotations: this.state.AnnotationLabel,
                    yAxis: {
                        gridLineWidth: gridlinesWidth,
                        minorGridLineWidth: gridlinesWidth, 
                        title: {
                        text: `<b>${xAxisLabel}</b>`
                        },
                        labels: {
                            enabled: disableYaxislabel
                        },
                        min: 0,
                        max: this.state.sliderValue
                    },            
                    legend: {
                        align: 'left',
                        verticalAlign: 'bottom',
                        useHTML: true,
                        enabled: disableLegend,
                        reversed: false,
                        //itemWidth:260,
                        itemStyle: {
                        'font-size': '14px',               
                        'letter-spacing': '0',
                        'line-height': '17px',
                        'text-align': 'center',
                                "textOverflow": "ellipsis"
                        },            
                    },
                    // legend: {
                    //     layout: 'vertical',
                    //     align: 'right',
                    //     verticalAlign: 'middle',
                    //     enabled: disableLegend
                    // },
                    tooltip: {
                        enabled: false,
                        // formatter: function() {
                        //     if(this.y < 12) {
                        //         return '<b>'+ this.y + ' AM' +'</b><br/>'+
                        //             'Date: '+ this.x;
                        //     } else {
                        //         let value =  (this.y) % 12
                        //         return '<b>'+ value + ' PM' +'</b><br/>'+
                        //             'Date: '+ this.x;
                        //     }
                        // }
                    },

                    xAxis: {
                        title: {
                            text: `<b>${yAxisLabel}</b>`,
                        },
                        tickLength: 0,
                        categories: xAxisDate,
                        labels: {
                            enabled: disableXaxislabel
                        },
                        plotLines: this.state.BaselineLabel && this.state.BaselineLabel != undefined &&  this.state.BaselineLabel[0] &&  this.state.BaselineLabel[0] != undefined ? this.state.BaselineLabel : [],
                    },

                    credits: {
                        enabled: false
                    },

                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            connectNulls: true,
                            //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                            fillOpacity: 0.6,
                            label: {
                                connectorAllowed: false
                            },
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    if(this.y < 12) {
                                        return '<b>'+ (this.y).toFixed(2) + ' AM' +'</b><br/>';//+'Date: '+ this.x;
                                    } else {
                                        let value =  (this.y) % 12
                                        return '<b>'+ value.toFixed(2) + ' PM' +'</b><br/>';//+'Date: '+ this.x;
                                    }
                                }
                            },
                            events: {
                                legendItemClick: function () {
                                    return false
                                }
                            },
                            marker: {
                                enabled: true        
                            }
                        }
                    },

                    series:  [finalData[arrIndex]],

                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom',
                                    enabled: disableLegend
                                }
                            }
                        }]
                    },

                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            x: -100
                        }
                    },

                    lang: {
                        contextButtonTitle: 'Click to open'
                    },

                    exporting: {
                        enabled: false
                    }

                    // exporting: {
                    //     buttons: {
                    //         contextButton: {
                    //             menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    //         }
                    //     },
                    //     chartOptions: {
                    //         colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                    //     }
                    // }
                });

                chart = Highcharts.chart(`analyticsDataDiv[${index}]`, {

                    chart: {
                        type: 'scatter',
                        zoomType: 'xy'
                    },

                    title: {
                        text: `<b>${graphTitle[arrIndex]}</b>`,
                    },
                    annotations: this.state.AnnotationLabel,
                    yAxis: {
                        gridLineWidth: gridlinesWidth,
                        minorGridLineWidth: gridlinesWidth, 
                        title: {
                        text: `<b>${xAxisLabel}</b>`
                        },
                        labels: {
                            enabled: disableYaxislabel
                        },
                        min: 0,
                        max: this.state.sliderValue
                    },            
                    legend: {
                        align: 'left',
                        verticalAlign: 'bottom',
                        useHTML: true,
                        enabled: disableLegend,
                        reversed: false,
                        //itemWidth:260,
                        itemStyle: {
                        'font-size': '14px',               
                        'letter-spacing': '0',
                        'line-height': '17px',
                        'text-align': 'center',
                                "textOverflow": "ellipsis"
                        },            
                    },
                    // legend: {
                    //     layout: 'vertical',
                    //     align: 'right',
                    //     verticalAlign: 'middle',
                    //     enabled: disableLegend
                    // },
                    tooltip: {
                        enabled: false,
                        // formatter: function() {
                        //     if(this.y < 12) {
                        //         return '<b>'+ this.y + ' AM' +'</b><br/>'+
                        //             'Date: '+ this.x;
                        //     } else {
                        //         let value =  (this.y) % 12
                        //         return '<b>'+ value + ' PM' +'</b><br/>'+
                        //             'Date: '+ this.x;
                        //     }
                        // }
                    },

                    xAxis: {
                        title: {
                            text: `<b>${yAxisLabel}</b>`,
                        },
                        tickLength: 0,
                        categories: xAxisDate,
                        labels: {
                            enabled: disableXaxislabel
                        },
                        plotLines: this.state.BaselineLabel && this.state.BaselineLabel != undefined &&  this.state.BaselineLabel[0] &&  this.state.BaselineLabel[0] != undefined ? this.state.BaselineLabel : [],
                    },

                    credits: {
                        enabled: false
                    },

                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            connectNulls: true,
                            //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                            fillOpacity: 0.6,
                            label: {
                                connectorAllowed: false
                            },
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    if(this.y < 12) {
                                        return '<b>'+ (this.y).toFixed(2) + ' AM' +'</b><br/>';//+'Date: '+ this.x;
                                    } else {
                                        let value =  (this.y) % 12
                                        return '<b>'+ value.toFixed(2) + ' PM' +'</b><br/>';//+'Date: '+ this.x;
                                    }
                                }
                            },
                            events: {
                                legendItemClick: function () {
                                    return false
                                }
                            },
                            marker: {
                                enabled: true        
                            }
                        }
                    },

                    series:  [finalData[arrIndex]],

                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom',
                                    enabled: disableLegend
                                }
                            }
                        }]
                    },

                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            x: -100
                        }
                    },

                    lang: {
                        contextButtonTitle: 'Click to open'
                    },

                    exporting: {
                        enabled: false
                    }

                    // exporting: {
                    //     buttons: {
                    //         contextButton: {
                    //             menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    //         }
                    //     },
                    //     chartOptions: {
                    //         colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                    //     }
                    // }
                });
                arrIndex = arrIndex + 1;
                chartArray.push(chart);
            }             

            this.setState({ chartArray: chartArray});            
        });    
        this.setState({ behaviorNameArray : behaviorNameArray.reverse()});
    }

    BatchExportToPDF = () => {  
        
        var zip = new JSZip();
        let svgArray = [];
        //var svg1 = getSVG([chart1, chart2]);
        this.state.chartArray.forEach((value, index) => {               
            var svg2 = getSVG([this.state.chartArray[index]]);
            //svgArray.push(svg1);
            svgArray.push(svg2);
          });
        
        let promises = [];
        for (let i = 0; i < svgArray.length; i++) {
          promises.push(svgToPng(svgArray[i], 0, 0));
        }
        Promise.all(promises).then((pngArr) => {
          if (pngArr.length) {
            //let count = 1;
            let i = 0;
            pngArr.forEach((data) => {
              var src = data.substr(data.indexOf(',') + 1);
             // zip.file('chart' + count + '.png', src, {
              zip.file(this.state.behaviorNameArray[i].replace(' ', '_') + '_' + i.toString() + '.png', src, {                
                base64: true
              });
              //count++;
              i++;
            });
            zip.generateAsync({
              type: "blob"
            }).then(function(blob) { // 1) generate the zip file
             // saveAs(blob, "charts.zip"); // 2) trigger the download
              downloaduploadedDocumentsOnAPICall(blob, "BehaviorReductionGraphs.zip");
            }, function(err) {
              console.log("error :", err);
            });
          }
        });
      };

    renderData() {
        let behaviorsReductionId1 = [];
        // console.log('data.claimServiceLines............',data.claimServiceLines)
        return this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.length > 0 && 
        this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.map((obj, index) => {            
            if(behaviorsReductionId1.indexOf(obj.behaviorsReductionId) === -1)
            {
                behaviorsReductionId1.push(obj.behaviorsReductionId);
                return (
                    <div id={`analyticsDataDiv[${index}]`} style={{ height: '500px' }} />           
                );
            }
        });
      };

    // onSliderChange = (value) => {     
    //     this.setState({
    //         sliderValue: value
    //     },()=> this.highchartsHandler());
    // }

    render() {
        // let { sliderValue } = this.state
        return (
            <div className='row'>
                {/* <div className='col-sm-auto'>
                    <Slider 
                        min={0}
                        max={this.state.sliderMaxValue}                           
                        value={sliderValue}
                        orientation="vertical"
                        onChange={(e)=>this.onSliderChange(e)}
                        tooltip={false}
                    />
                </div> */}
                <div className='col-sm-11'>
                    {this.state.xAxisDateOption.length > 0 ? 
                    <div className='row'>
                        <div className='col-sm-3'><GraphAnnotation setAnnotationState={this.setAnnotationState} xAxisDateOption={this.state.xAxisDateOption}/></div>
                        <div className='col-sm-3'><GraphPlotline setBaselineState={this.setBaselineState} xAxisDateOption={this.state.xAxisDateOption}/></div>
                        <div className='col-sm-3'>
                            {/* <RaisedButton className="grey_btn ml_15" onTouchTap={(e) => this.BatchExportToPDF(e)} >Batch Export To PDF</RaisedButton> */}                                
                            <div className='row'>
                                <div className="col-12 col-sm-12 col-md-12 btn_lft reset-btn claims_filter mt-20">
                                    <RaisedButton className="grey_btn" type="Submit" primary={true}  onTouchTap={(e) => this.BatchExportToPDF(e)} >Download all Graphs</RaisedButton>                                      
                                </div>
                            </div>
                        </div>   
                        <div className='col-sm-3'></div>
                    </div>
                     : null}
                     {this.renderData()}                        
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        dataAnalytics: state.dcSkillAcquisitionBatchGraph
    };
}

export default connect(mapStateToProps, null)(TimeOfDayGraph)


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionBatchGraph/BehaviourGraph/TimeOfDayGraph.js